import { Typography } from '@sanlam-glacier/app-common/components';
import StatementDropdown from '../../../../atoms/statement-dropdown/StatementDropdown';
import styles from './transaction-detail-dropdown.module.scss';
import SecondaryDropdown from '../../../../atoms/secondary-dropdown/SecondaryDropdown';
import { format } from 'date-fns';
import { TransactionDetailResponseMock } from 'modules/clients/types/client.interfaces';
import { TransactionDetailTable } from '../transaction-detail-table/TransactionDetailTable';
import { useState } from 'react';
import { formattingTransactionDetail } from 'modules/clients/utils/format-transaction-detail-data';

type TransactionDetailDropdownProps = {
  startDate: Date;
  endDate: Date;
  transactionDetail: TransactionDetailResponseMock;
};

const TransactionDetailDropdown = ({
  startDate,
  endDate,
  transactionDetail
}: TransactionDetailDropdownProps) => {
  const transactiondetailFormattedData = formattingTransactionDetail(
    transactionDetail.transactions
  );

  const numberOfTransDetailCategories = transactiondetailFormattedData.length;
  const [childrenDropdownState, setChildrenDropdownState] = useState<Record<number, boolean>>(
    () => {
      const initial: Record<number, boolean> = {};
      for (let i = 0; i < numberOfTransDetailCategories; i++) {
        initial[i] = true;
      }
      return initial;
    }
  );

  const parentIsOpen = Object.values(childrenDropdownState).some((isOpen) => isOpen);

  const handleChildToggle = (id: number) => {
    setChildrenDropdownState((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const handleParentToggle = () => {
    const newState = !parentIsOpen;
    const updatedChildren: Record<number, boolean> = {};
    Object.keys(childrenDropdownState).forEach((key) => {
      updatedChildren[Number(key)] = newState;
    });
    setChildrenDropdownState(updatedChildren);
  };

  const subtitle = () => {
    return (
      <div className={styles.subtitleContainer}>
        <Typography variant={Typography.VARIANT.B2} weight={Typography.WEIGHT.MEDIUM}>
          Transaction detail:
        </Typography>
        &nbsp;
        <Typography variant={Typography.VARIANT.B2} weight={Typography.WEIGHT.NORMAL}>
          {format(startDate, 'yyyy-MM-dd')} to {format(endDate, 'yyyy-MM-dd')}
        </Typography>
      </div>
    );
  };

  return (
    <StatementDropdown
      title={`${transactionDetail.investmentNumber}: ${transactionDetail.investmentName}`}
      subtitle={subtitle()}
      shoudShowCollapse={true}
      testid=''
      buttonTitle='investment'
      isOpen={parentIsOpen}
      onToggle={handleParentToggle}
    >
      {({ isDropdownCollapsed }) => (
        <>
          <div className={styles.contentContainer}>
            <Typography variant={Typography.VARIANT.B3}>
              This section shows the full transaction details for the selected period.
            </Typography>
            <div>
              <div className={styles.contentContainer}>
                {transactiondetailFormattedData.map((transactionCategory, index) => (
                  <SecondaryDropdown
                    key={`${transactionCategory.title}_${index}`}
                    title={transactionCategory.title}
                    amountDescription={transactionCategory.amountDescription}
                    amount={transactionCategory.totalTargetAmount}
                    shouldHaveBorder={transactionCategory.shouldHaveBorder}
                    id={index}
                    isOpen={childrenDropdownState[index] ?? true}
                    onToggle={handleChildToggle}
                  >
                    {({ isOpen }) => (
                      <>
                        {isOpen && isDropdownCollapsed && (
                          <TransactionDetailTable
                            transactions={transactionCategory.transactions}
                            totalSourceAmount={transactionCategory.totalSourceAmount}
                            totalTargetAmount={transactionCategory.totalTargetAmount}
                          />
                        )}
                      </>
                    )}
                  </SecondaryDropdown>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </StatementDropdown>
  );
};

export default TransactionDetailDropdown;
